// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-container[data-v-013110ca]{width:4rem;height:4rem;border-radius:50%;background:#0096cc;display:flex;justify-content:center;align-items:center}.icon[data-v-013110ca]{border-radius:50%;background:#fff}.icon-0[data-v-013110ca]{width:1.6rem;height:1.6rem}.icon-1[data-v-013110ca]{width:2.5rem;height:2.5rem}.icon-2[data-v-013110ca]{width:3.2rem;height:3.2rem}", ""]);
// Exports
module.exports = exports;
